import './WeatherForecast.css';

interface WeatherBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: string;
  value: number | string;
  unit: string;
  className: string;
}

export function WeatherBadge({
  icon,
  value,
  unit,
  className,
  ...rest
}: WeatherBadgeProps) {
  return (
    <span className={`weather-badge ${className}`} {...rest}>
      <i className={`bi ${icon} me-2 icon-weather`} />
      {value} {unit}
    </span>
  );
}
